export default "__VITE_ASSET__y8W7l_d7__"